import React from 'react';
import { Col, Row } from 'reactstrap';
import { Badge } from '@core/frontend/ui';
import { isAchievementUnlocked } from '@core/shared';
import { useProjectPageConfig } from '@core/frontend/stores';
import thumbnailPlaceholder from '../../assets/images/project-thumbnail-placeholder.webp';
import { achievementBadgeAssets } from '../../shared/badgeAssets.js';
import classes from './Project.module.scss';

/**
 * Medienblock der Projekt-Detailseite (Cassiopeia).
 *
 * Thumbnail bzw. erstes Galeriebild plus die Abzeichen-Reihe darueber. Der Kern rendert
 * diesen Slot nur, wenn `projectDetailComponents.Media` gesetzt ist; Bigfoot hat keinen.
 * Die Grafiken der Abzeichen bleiben App-Assets (`achievementBadgeAssets`).
 */
const ProjectMedia = ({ project }) => {
    const { defaultThumbnailUrl } = useProjectPageConfig();
    const achievements = Array.isArray(project.achievements) ? project.achievements : [];
    const gallery = project.projectGallery || [];
    const imageUrl = gallery.length > 0 ? gallery[0].url : defaultThumbnailUrl || thumbnailPlaceholder;

    return (
        <Row className="pb-3 pt-1 position-relative">
            <Col xs="12">
                <div className={classes.CardImage} style={{ backgroundImage: `url(${imageUrl})` }} />
            </Col>
            {achievements.length > 0 && (
                <Row className="position-absolute w-100 h-100 m-0 top-0 justify-content-end pe-2">
                    <Badge
                        type="isReferral"
                        isAchieved={isAchievementUnlocked(achievements, 'isReferral')}
                        linkTo="/errungenschaften#isReferral"
                        assets={achievementBadgeAssets}
                    />
                    <Badge
                        type="hasReferred"
                        isAchieved={isAchievementUnlocked(achievements, 'hasReferred')}
                        linkTo="/errungenschaften#hasReferred"
                        assets={achievementBadgeAssets}
                    />
                    <Badge
                        type="whatsAppShares"
                        isAchieved={isAchievementUnlocked(achievements, 'whatsAppShares')}
                        linkTo="/errungenschaften#whatsAppShares"
                        assets={achievementBadgeAssets}
                    />
                    <Badge
                        type="facebookShares"
                        isAchieved={isAchievementUnlocked(achievements, 'facebookShares')}
                        linkTo="/errungenschaften#facebookShares"
                        assets={achievementBadgeAssets}
                    />
                    <Badge
                        type="emailShares"
                        isAchieved={isAchievementUnlocked(achievements, 'emailShares')}
                        linkTo="/errungenschaften#emailShares"
                        assets={achievementBadgeAssets}
                    />
                </Row>
            )}
        </Row>
    );
};

export default ProjectMedia;
